import { render, staticRenderFns } from "./EditTerm.vue?vue&type=template&id=49a366c0&scoped=true"
import script from "./EditTerm.vue?vue&type=script&lang=js"
export * from "./EditTerm.vue?vue&type=script&lang=js"
import style0 from "./EditTerm.vue?vue&type=style&index=0&id=49a366c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a366c0",
  null
  
)

export default component.exports